import { useTranslation } from 'react-i18next'
import { Alert, AlertTitle, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import { useConfluencePage } from '../hooks/useConfluencePage'
import { ConfluencePages } from '../enums'
import { useLanguage } from '../contexts/LanguageContext'
import Language from '../enums/Language'
import ConfluencePageArticle from './ConfluencePageArticle'
import LoadingState from './LoadingState'
import { Valve } from '../types'

export interface ValveAttachInRuuviTagInstructionsProps {
  valve?: Valve
}

export default function ValveAttachInRuuviTagInstructions(
  _: ValveAttachInRuuviTagInstructionsProps
) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  /**
   * The language.
   */
  const { language } = useLanguage()

  /**
   * The Confluence page ID.
   */
  const pageId = initializePageId()

  /**
   * Initialize the Confluence page ID based on the current language.
   */
  function initializePageId(): string {
    switch (language) {
      case Language.FINNISH:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_FI
      case Language.SWEDISH:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_SE
      case Language.NORWEGIAN_BOKMÅL:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_NO
      case Language.GERMAN:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_DE
      case Language.SPANISH:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_ES
      case Language.FRENCH:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_FR
      case Language.DUTCH:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_NL
      case Language.ENGLISH_US:
      default:
        return ConfluencePages.VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_EN
    }
  }

  /**
   * The Confluence page.
   */
  const { page, isLoading } = useConfluencePage(pageId)

  return (
    <>
      {isLoading ? (
        <LoadingState />
      ) : page ? (
        <ConfluencePageArticle page={page} />
      ) : (
        <Alert severity="info">
          <AlertTitle sx={{ mt: 0 }}>{t('ValveAttachInRuuviTagInstructions.title')}</AlertTitle>

          <List>
            <ListItem sx={{ py: 1 }}>
              <ListItemAvatar sx={{ minWidth: 16 }}>1.</ListItemAvatar>
              <ListItemText primary={t('ValveAttachInRuuviTagInstructions.stepOne')} />
            </ListItem>
            <ListItem sx={{ py: 1 }}>
              <ListItemAvatar sx={{ minWidth: 16 }}>2.</ListItemAvatar>
              <ListItemText primary={t('ValveAttachInRuuviTagInstructions.stepTwo')} />
            </ListItem>
            <ListItem sx={{ py: 1 }}>
              <ListItemAvatar sx={{ minWidth: 16 }}>3.</ListItemAvatar>
              <ListItemText primary={t('ValveAttachInRuuviTagInstructions.stepThree')} />
            </ListItem>
          </List>
        </Alert>
      )}
    </>
  )
}
